.matchScores {
  display: flex;
  flex-flow: row;

  &.multiline {
    flex-wrap: wrap;
  }
}

.matchScore {
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    padding-right: var(--spacingLg);
  }

  .bold {
    font-weight: var(--fontWeightBold);
  }

  .thin {
    font-weight: var(--fontWeightLight);
  }

  .title {
    color: var(--paletteBlue2);
  }

  .light {
    color: var(--paletteWhite0);
  }

  .value {
    display: flex;
    width: fit-content;
  }

  .unit {
    display: flex;
    align-items: end;
    margin-bottom: var(--spacingSm);
  }
}
